'use strict';
// write your code here
var elements = document.querySelectorAll('.population');
var valueAvarage = document.querySelector('.average-population');
var valueTotal = document.querySelector('.total-population');
var summaPopulation = 0;
elements.forEach(function(el) {
    return summaPopulation = summaPopulation + Number(el.textContent.replaceAll(',', ''));
});
valueTotal.textContent = summaPopulation.toLocaleString('en-US');
valueAvarage.textContent = Math.floor(summaPopulation / elements.length).toLocaleString('en-US');

//# sourceMappingURL=js_get_data_DOM.195b7d6a.js.map
